<!-- Loading State -->
@if (loading) {
  <div class="flex justify-center items-center h-64">
    <div data-testid="stock-view-loading" class="text-gray-500">
      {{ "virtual_warehouse_transfer.form.messages.loading" | translate }}
    </div>
  </div>
}

<!-- Content -->
@if (viewData && !loading) {
  @if (formFields.length > 0) {
    <app-add-form
      data-testid="stock-view-form"
      [formFields]="formFields"
      [initialData]="formData"
      [viewMode]="true"
      [title]="pageTitle"
      (formAction)="onFormAction($event)"
    ></app-add-form>
  }
}

<!-- Error State -->
@if (!viewData && !loading) {
  <div class="flex justify-center items-center h-64">
    <div class="text-center">
      <div class="text-gray-500 text-lg mb-2">
        {{
          "virtual_warehouse_transfer.form.messages.no_data_found" | translate
        }}
      </div>
      <p-button
        data-testid="stock-view-go-back-btn"
        [label]="'virtual_warehouse_transfer.form.messages.go_back' | translate"
        [outlined]="true"
        severity="secondary"
        (onClick)="onBack()"
      ></p-button>
    </div>
  </div>
}
